import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { MsalService } from './msal.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(private msalService: MsalService, private router: Router) { }
    async canActivate(): Promise<boolean> {
        const isLoggedIn = await this.msalService.checkIfLoggedIn();
        if (isLoggedIn) {
            return true; // Allow navigation
        } else {
            // Redirect to login page if user is not authenticated
          //  this.router.navigate(['']);
        //  this.msalService.login();
        // if(this.msalService.first == true ){
        //     this.msalService.first = false;
            this.msalService.login();
       // }else{
       //     this.router.navigate(['/signin']);
        }
            return false;
        }
    }

